import apiRequest from '../config/api'

export interface DashboardData {
  live_teaching: number
  cbt: number
  users: number
  courses: number
  registrants: string
  revenue: string
  certificate: number
}

export interface ChartData {
  revenue: {
    weekly: {
      day_1: string
      day_2: string
      day_3: string
      day_4: string
      day_5: string
      day_6: string
      day_7: string
    }
    monthly: {
      week_1: string
      week_2: string
      week_3: string
      week_4: string
    }
    yearly: {
      january: string
      february: string
      march: string
      april: string
      may: string
      june: string
      july: string
      august: string
      september: string
      october: string
      november: string
      december: string
    }
  }
}

export interface DashboardResponse {
  message: string
  data: DashboardData
  chart: ChartData
}

export const dashboardApi = {
  getAdminDashboard: async (): Promise<DashboardResponse> => {
    const response = await apiRequest.get<DashboardResponse>(
      '/api/admin/dashboard',
    )
    return response.data
  },
}
